import defaultContent from '../../../content/permissionRoleGroupDetail';
import { useTranslation } from 'react-i18next';
import Title from '../../common/Title/Title';
import { Input } from '../../common/Input/Input';
import Button from '../../common/Button/Button';
import SelectComponent from '../../common/Select/Select';
import { mockRoles, mockStatus } from '../../../mocks/data';

export const PermissionRoleGroupDetail = () => {
  const { t } = useTranslation(['permissionRoleGroupDetail']);
  const title = t(
    'permissionRoleGroupDetail',
    defaultContent['permissionRoleGroupDetail'],
  ).toString();

  const permissionRoleGroupDetail = (
    <div className="container">
      <Title text={title} />
      <div className="h-3"></div>
      <div className="row">
        <div className="column-two">
          <Input label={'Permission Group Name'} readOnly={false} />
        </div>
        <div className="column-two">
          <SelectComponent isMulti={false} label={'Status'} options={mockStatus} />
        </div>
      </div>
      <div className="h-1"></div>
      <div className="row">
        <div className="column-one">
          <SelectComponent isMulti={true} label={'Assigned Roles'} options={mockRoles} />
        </div>
      </div>
      <div className="h-2"></div>
      <div className="row">
        <div className="column-one">
          <Button
            text="Save Changes"
            color="primary-purple"
            disabled={false}
            action={function (): void {
              throw new Error('Function not implemented.');
            }}
          />
          <span className="spacing-one"></span>
          <Button
            text="Cancel"
            color="primary-white"
            disabled={false}
            action={function (): void {
              throw new Error('Function not implemented.');
            }}
          />
        </div>
      </div>
    </div>
  );

  return <>{permissionRoleGroupDetail}</>;
};

export default PermissionRoleGroupDetail;
